import React from "react";
import { useNavigate } from "react-router-dom";
import { Users, Briefcase, Rocket } from "lucide-react";

const TABS = [
  { key: "team", label: "Team / Human Capital", to: "/cohort/consultant", Icon: Users },
  { key: "bg", label: "Business Growth Cohorts", to: "/b2m/consultant?section=bg", Icon: Briefcase },
  { key: "b2m", label: "Brand2Market\u2122", to: "/b2m/consultant?section=b2m", Icon: Rocket },
];

// Unified consultant control-centre navigation shared by both dashboards.
// `onSelectSection` (optional) lets the B2M page switch bg/b2m in-page; the
// Team tab always routes to /cohort/consultant. Auth token is shared across both.
export function ConsultantNav({ active, onSelectSection, gold = "#D6A25A", ink = "#141A32" }) {
  const navigate = useNavigate();
  const go = (t) => {
    if (t.key !== "team" && onSelectSection) { onSelectSection(t.key); return; }
    navigate(t.to);
  };
  return (
    <div className="flex flex-wrap gap-2" data-testid="consultant-nav">
      {TABS.map((t) => (
        <button
          key={t.key}
          data-testid={`consultant-nav-${t.key}`}
          onClick={() => go(t)}
          className="flex items-center gap-2 rounded-full px-4 py-2 text-sm font-bold transition-colors"
          style={active === t.key
            ? { background: gold, color: ink }
            : { color: "#E5E7EB", border: "1px solid rgba(180,185,205,0.45)", background: "transparent" }}
        >
          <t.Icon className="h-4 w-4" style={{ color: active === t.key ? ink : gold }} /> {t.label}
        </button>
      ))}
    </div>
  );
}
